"use client";

import { c as _c } from "react/compiler-runtime";
import { Track } from "@opensea/analytics";
import { Add } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useAuthenticatedCallback } from "@/hooks/use-authenticated-callback";
import { useLinkedWalletModalStore } from "@/stores/use-linked-wallet-modal-store";
import { AccountSwitcherItem, AccountSwitcherItemAvatar, AccountSwitcherItemContent, AccountSwitcherItemTitle } from "./AccountSwitcherItem";
export function AccountSwitcherConnectItem(props) {
  const $ = _c(12);
  const t = useTranslations("AccountSwitcherConnectItemV2");
  const {
    setIsLinkedWalletModalOpen
  } = useLinkedWalletModalStore();
  let t0;
  if ($[0] !== setIsLinkedWalletModalOpen) {
    t0 = () => {
      setIsLinkedWalletModalOpen(true);
    };
    $[0] = setIsLinkedWalletModalOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const openLinkedWalletModal = useAuthenticatedCallback(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      event: "Connect Click",
      data: {
        source: "Account Switcher"
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AccountSwitcherItemAvatar className="text-inherit" icon={Add} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("connectTitle");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <AccountSwitcherItemContent><AccountSwitcherItemTitle className="text-inherit">{t3}</AccountSwitcherItemTitle></AccountSwitcherItemContent>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== openLinkedWalletModal || $[9] !== props || $[10] !== t4) {
    t5 = <Track click={t1}><AccountSwitcherItem onClick={openLinkedWalletModal} {...props}>{t2}{t4}</AccountSwitcherItem></Track>;
    $[8] = openLinkedWalletModal;
    $[9] = props;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}